import { Theme } from "@mui/material";

const useStyles = (theme: Theme) => ({
  steppers: {
    mt: "-10px",
    zIndex: 11000,
    width: "500px",
    position: "absolute",
    top: "30px",
    left: "0px",
    right: "0px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  stackPage: {
    width: "100%",
    height: "100%",
    padding: { xs: "10%", md: "50px" },
  },
  paperForm: {
    padding: "24px 32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: { xs: "100%", md: "500px" },
    minWidth: "200px",
    gap: "12px",
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
  },
  subtitle: {
    fontSize: "14px",
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  sectionTitle: {
    fontSize: "16px",
    color: theme.palette.text.secondary,
  },
  termsStack: {
    width: "100%",
    direction: "row",
    justifyContent: "start",
    alignItems: "center",
  },
  termsText: {
    fontSize: "16px",
  },
  link: {
    ml: "5px",
    textDecoration: "none",
  },
  loginText: {
    fontSize: "16px",
    color: theme.palette.text.secondary,
  },
});

export default useStyles;
